import { LeadCurd } from "./leadCrud";

export default function SaleLeads() {
  return <LeadCurd name="再分配客户" type="my" router="saleLeads" />;
}
